export { Tag, type TagProps } from './Tag';
export { tagVariants } from './Tag.styles';
